var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHanger = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 84,
    height: 84
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.132 50.912-20.656-14.45c-.215-.173-.51-.273-.724-.418a2.334 2.334 0 0 1 1.072-1.89c5.36-4.108-.473-12.097-5.888-8.034-1.697 1.181-3.09 5.38-.107 5.69.952-.026 1.718-.805 1.742-1.773a1.463 1.463 0 0 1 1.267-1.43 1.448 1.448 0 0 1 1.574 1.066 1.502 1.502 0 0 1-.58 1.573 5.91 5.91 0 0 0-2.565 4.798c-.214.145-.509.245-.723.418l-20.656 14.45c-1.573 1.102-2.258 3.117-1.69 4.97.567 1.857 2.255 3.12 4.165 3.118h41.294c1.903-.011 3.58-1.275 4.145-3.124.566-1.847-.11-3.856-1.67-4.964Zm-1.68 3.916a.824.824 0 0 1-.83.627h-41.26a.825.825 0 0 1-.794-.627.836.836 0 0 1 .303-1L41.519 39.38a.82.82 0 0 1 .983 0l20.647 14.45c.322.218.45.636.304 1Z",
    fill: "currentColor"
  }))));
};
export { SvgHanger as ReactComponent };